import React, { useState, useEffect } from "react"
import Grid from "@material-ui/core/Grid"
import Layout from "../components/layout"
import axios from "axios"
import Loading from "./loading"
import PremiumServices from "../components/Sidebar/PremiumServices"
// import { Link } from "gatsby"
import Seo from "../components/seo"
// import { makeStyles } from "@material-ui/core/styles"
import "../components/pageStyles.scss"

// const useStyles = makeStyles(theme => ({
//   root: {
//     "&:focus": {
//       backgroundColor: "hsl(208, 89%, 34%) !important",
//       color: "#fff !important",
//     },

//   },
// }))

const DropDown = props => {
  const handleClickYear = event => {
    props.handleDropDownChangeYear(event.target.value)
  }
  const handleClickMonth = event => {
    props.handleDropDownChangeMonth(event.target.value)
  }
  var d = new Date()
  var thisYear = d.getFullYear()

  return (
    <React.Fragment>
      <label htmlFor="yearSelector" style={{ marginRight: "5px" }}>
        <b>Year:</b>{" "}
      </label>
      <select
        id="yearSelector"
        value={props.year}
        style={{
          fontSize: "18px",
          fontFamily: "proxima-nova,sans-serif",
          marginBottom: "25px",
        }}
        onChange={handleClickYear}
      >
        <option value={thisYear}>{thisYear}</option>
        <option value={thisYear - 1}>{thisYear - 1}</option>
        <option value={thisYear - 2}>{thisYear - 2}</option>
        <option value={thisYear - 3}>{thisYear - 3}</option>
        <option value={thisYear - 4}>{thisYear - 4}</option>
        <option value={thisYear - 5}>{thisYear - 5}</option>
        <option value={thisYear - 6}>{thisYear - 6}</option>
        <option value={thisYear - 7}>{thisYear - 7}</option>
        <option value={thisYear - 8}>{thisYear - 8}</option>
        <option value={thisYear - 9}>{thisYear - 9}</option>
        <option value={thisYear - 10}>{thisYear - 10}</option>
        <option value={thisYear - 11}>{thisYear - 11}</option>
      </select>

      <label
        htmlFor="monthSelector"
        style={{ marginRight: "5px", marginLeft: "5px" }}
      >
        <b>Month:</b>
      </label>
      <select
        id="monthSelector"
        value={props.month}
        style={{
          fontSize: "18px",
          fontFamily: "proxima-nova,sans-serif",
          marginBottom: "25px",
        }}
        onChange={handleClickMonth}
      >
        <option value="jan">January</option>
        <option value="feb">February</option>
        <option value="mar">March</option>
        <option value="apr">April</option>
        <option value="may">May</option>
        <option value="jun">June</option>
        <option value="jul">July</option>
        <option value="aug">August</option>
        <option value="sep">September</option>
        <option value="oct">October</option>
        <option value="nov">November</option>
        <option value="dec">December</option>
        <option value="year">Year</option>
      </select>
    </React.Fragment>
  )
}

const JerseyClimateData = props => {
  return (
    <div
      style={{ textAlign: "center", marginTop: "20px", marginBottom: "30px" }}
    >
      <img alt="" src={props.url}  style={{maxWidth:"727px"}}/>
    </div>
  )
}

const JerseyClimate = () => {
  const [data, setData] = useState([])


  let d = new Date();
  let yearCurrent = d.getFullYear()
  let monthCurrent = d.toLocaleString('en-gb', { month: 'short' }).toLowerCase()
  if (d.getMonth()===0)
  {
    d.setMonth(-1)
    yearCurrent = d.getFullYear()
    monthCurrent = d.toLocaleString('en-gb', { month: 'short' }).toLowerCase()
  }

  const [year, setYear] = useState(yearCurrent)
  const [month, setMonth] = useState(monthCurrent)
  const [url] = useState(process.env.MET_JERSEYCLIMATE)
  const [loading, setloading] = useState(true)
  const [error, setError] = useState(false)
  const [pageTitle, setPageTitle] = useState("")

  useEffect(() => {
    const fetchData = async () => {
      setError(false)
      setloading(true)
      try {
        const result = await axios(url + "&year=" + year + "&month=" + month)
        setData(result.data)
      } catch (error) {
        setError(true)
        console.log(error)
      }
      if (month === "jan") setPageTitle(`Jersey climate January ${year}`)
      if (month === "feb") setPageTitle(`Jersey climate February ${year}`)
      if (month === "mar") setPageTitle(`Jersey climate March ${year}`)
      if (month === "apr") setPageTitle(`Jersey climate April ${year}`)
      if (month === "may") setPageTitle(`Jersey climate May ${year}`)
      if (month === "jun") setPageTitle(`Jersey climate June ${year}`)
      if (month === "jul") setPageTitle(`Jersey climate July ${year}`)
      if (month === "aug") setPageTitle(`Jersey climate August ${year}`)
      if (month === "sep") setPageTitle(`Jersey climate September ${year}`)
      if (month === "oct") setPageTitle(`Jersey climate October ${year}`)
      if (month === "nov") setPageTitle(`Jersey climate November ${year}`)
      if (month === "dec") setPageTitle(`Jersey climate December ${year}`)
      if (month === "year") setPageTitle(`Jersey climate ${year}`)
      setloading(false)
    }
    fetchData()
  }, [month, year, url])

  return (
    <Layout>
      <Seo title="Jersey climate" description="Climate data for Jersey, Channel Islands from Jersey’s Meteorological Department" />
      <div className="forecastAutoMargin">
      <Grid item xs={12} sm={12} md={8} lg={8} className="menuTitle" style={{paddingLeft:0}}>
                  <h1>
                  {pageTitle}
                  </h1>                  
      </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={8} lg={8}>
            <div className="Content">
              {error ? (
                <React.Fragment>
                  <DropDown
                    month={month}
                    year={year}
                    handleDropDownChangeYear={DropDownValue =>
                      setYear(DropDownValue)
                    }
                    handleDropDownChangeMonth={DropDownValue =>
                      setMonth(DropDownValue)
                    }
                  />
                  <p>
                  For an official report or verified data, email <a className="hover-link" href = "mailto: jerseymetadmin@gov.je">jerseymetadmin@gov.je</a> 
                  </p>
                  <div>
                    <p style={{ color: "#bf0d0d" }}>Climate data unavailable</p>
                  </div>
                </React.Fragment>
              ) : loading ? (
                <Loading />
              ) : (
                <React.Fragment>
                  <DropDown
                    month={month}
                    year={year}
                    handleDropDownChangeYear={DropDownValue =>
                      setYear(DropDownValue)
                    }
                    handleDropDownChangeMonth={DropDownValue =>
                      setMonth(DropDownValue)
                    }
                  />
                  <p>
                  For an official report or verified data, email <a className="hover-link" href = "mailto: jerseymetadmin@gov.je">jerseymetadmin@gov.je</a> 
                  </p>
               
                  {data.map(result => (
                    <JerseyClimateData key={result.id} {...result} />
                  ))}
                </React.Fragment>
              )}
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <PremiumServices />
          </Grid>
        </Grid>
      </div>
    </Layout>
  )
}
export default JerseyClimate
